"use client";

import { motion } from "framer-motion";

import styles from "../styles";
import { insights } from "../constants";
import { InsightCard } from "../components";

const Insights = () => (
  <section className={`${styles.paddings} relative z-10`}>
    <motion.div
      className={`${styles.innerWidth} mx-auto flex flex-col`}>
      <div className="mt-[50px] flex flex-col gap-[26px]">
        {insights.map((item, index) => (
          <InsightCard key={`insight-${index}`} {...item} index={index + 1} />
        ))}
      </div>
    </motion.div>
  </section>
);

export default Insights;
